import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full bg-white rounded-xl p-6 flex flex-col justify-start shadow-modal"
}
const _hoisted_2 = { class: "grid grid-cols-[1fr, 200px, 200px] justify-between items-center gap-4 mdlg:gap-6" }
const _hoisted_3 = { class: "t-18m md:t-22m -order-2 text-wrh-blue-dark mdlg:row-span-1 mdlg:col-start-1 mdlg:col-end-2" }
const _hoisted_4 = { class: "t-12r mdlg:t-14r text-wrh-gray-dark mdlg:row-span-1 mdlg:col-start-1 mdlg:col-end-2" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "hidden" }, "You haven’t selected a preferred lender", -1)

import { computed, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { IMortage } from '@/models';
import { getMortage } from '@/api';
import PreferredLenderSkeleton from '@/components/skeleton/PreferredLenderSkeleton.vue';
import { StoreActions } from '@/constants';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const showSkeleton = ref(false);

const mortgageData = computed(() => store.getters.getMortage as IMortage);
onMounted(async () => {
  showSkeleton.value = true;
  if (!mortgageData.value.title) {
    const response = await getMortage();
    store.dispatch(StoreActions.SET_MORTAGE, response);
  }
  showSkeleton.value = false;
});

const redirect = () => {
  window.open(mortgageData.value.link, '_blank');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (Object.keys(_unref(mortgageData)).length && !showSkeleton.value)
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(mortgageData).title), 1),
            _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(mortgageData).description), 1),
            _createElementVNode("img", {
              src: _unref(mortgageData).logo,
              alt: _unref(mortgageData).title,
              width: "120",
              height: "66",
              class: "w-22 -order-1 mdlg:w-30 mdlg:col-start-2 mdlg:col-end-3 mdlg:row-start-1 mdlg:row-end-3"
            }, null, 8, _hoisted_5),
            _hoisted_6,
            _createElementVNode("button", {
              class: "t-14m px-14 py-2 rounded bg-wrh-blue-light text-white mdlg:row-start-1 mdlg:row-end-3 mdlg:col-start-3 mdlg:col-end-4 hover:bg-wrh-blue-600 focus:outline-none transition-colors duration-300 ease-in-out",
              onClick: redirect
            }, " Go to HLX ")
          ])
        ]))
      : _createCommentVNode("", true),
    (showSkeleton.value)
      ? (_openBlock(), _createBlock(PreferredLenderSkeleton, { key: 1 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})